import React, { memo } from "react";

const svgProps = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

export const IconPortfolio = memo(function IconPortfolio() {
  return (
    <svg {...svgProps}>
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  );
});

export const IconCostBasis = memo(function IconCostBasis() {
  return (
    <svg {...svgProps}>
      <rect x="4" y="2" width="16" height="20" rx="2" />
      <line x1="8" y1="6" x2="16" y2="6" />
      <line x1="8" y1="10" x2="16" y2="10" />
      <line x1="8" y1="14" x2="12" y2="14" />
    </svg>
  );
});

export const IconUnrealisedPnl = memo(function IconUnrealisedPnl() {
  return (
    <svg {...svgProps}>
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  );
});

export const IconWallet = memo(function IconWallet() {
  return (
    <svg {...svgProps}>
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
    </svg>
  );
});

export const IconSharesRedeemed = memo(function IconSharesRedeemed() {
  return (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12l3 3 5-6" />
    </svg>
  );
});

export const IconReferralLink = memo(function IconReferralLink() {
  return (
    <svg {...svgProps}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  );
});

export const IconCopy = memo(function IconCopy() {
  return (
    <svg {...svgProps}>
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
});

export const IconDashboard = memo(function IconDashboard() {
  return (
    <svg {...svgProps}>
      <rect x="3" y="3" width="7" height="9" />
      <rect x="14" y="3" width="7" height="5" />
      <rect x="14" y="12" width="7" height="9" />
      <rect x="3" y="16" width="7" height="5" />
    </svg>
  );
});

export const IconKyc = memo(function IconKyc() {
  return (
    <svg {...svgProps}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
});

export const IconPriceUpdate = memo(function IconPriceUpdate() {
  return (
    <svg {...svgProps}>
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
});

export const IconOpportunities = memo(function IconOpportunities() {
  return (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
    </svg>
  );
});

export const IconRedeemedProjects = memo(function IconRedeemedProjects() {
  return (
    <svg {...svgProps}>
      <path d="M3 21h18" />
      <path d="M5 21V7l8-4v18" />
      <path d="M19 21V11l-6-4" />
      <path d="M9 9v.01" />
      <path d="M9 12v.01" />
      <path d="M9 15v.01" />
      <path d="M9 18v.01" />
    </svg>
  );
});

export const IconClosedProjects = memo(function IconClosedProjects() {
  return (
    <svg {...svgProps}>
      <rect x="2" y="3" width="20" height="5" rx="1" />
      <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" />
      <path d="M10 12h4" />
    </svg>
  );
});

export const IconCancelled = memo(function IconCancelled() {
  return (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );
});

const METRIC_ICON_BY_KEY = {
  portfolio: IconPortfolio,
  cost: IconCostBasis,
  pnl: IconUnrealisedPnl,
  wallet: IconWallet,
  redeemed: IconSharesRedeemed,
};

export const IconReports = memo(function IconReports() {
  return (
    <svg {...svgProps}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  );
});

export const IconNotifications = memo(function IconNotifications() {
  return (
    <svg {...svgProps}>
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
});

export const IconTransfer = memo(function IconTransfer() {
  return (
    <svg {...svgProps}>
      <path d="M7 7h10" />
      <path d="M17 7l-3-3" />
      <path d="M17 7l-3 3" />
      <path d="M7 17h10" />
      <path d="M7 17l3-3" />
      <path d="M7 17l3 3" />
    </svg>
  );
});

export const IconDeposit = memo(function IconDeposit() {
  return (
    <svg {...svgProps}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <polyline points="19 12 12 19 5 12" />
    </svg>
  );
});

export const IconWithdraw = memo(function IconWithdraw() {
  return (
    <svg {...svgProps}>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </svg>
  );
});

export const IconRedeemable = memo(function IconRedeemable() {
  return (
    <svg {...svgProps}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
    </svg>
  );
});

export const IconOfferHistory = memo(function IconOfferHistory() {
  return (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
});

export const IconWalletActivity = memo(function IconWalletActivity() {
  return (
    <svg {...svgProps}>
      <line x1="8" y1="6" x2="21" y2="6" />
      <line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" />
      <line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" />
      <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  );
});

export const IconFundraising = memo(function IconFundraising() {
  return (
    <svg {...svgProps}>
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </svg>
  );
});

export const IconFunded = memo(function IconFunded() {
  return (
    <svg {...svgProps}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
});

export const IconFilter = memo(function IconFilter() {
  return (
    <svg {...svgProps}>
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  );
});

const SECTION_ICON_BY_KEY = {
  dashboard: IconDashboard,
  "portfolio-overview": IconDashboard,
  kyc: IconKyc,
  portfolio: IconPortfolio,
  holdings: IconPortfolio,
  "shares-management": IconPortfolio,
  wallet: IconWallet,
  "main-wallet": IconWallet,
  reports: IconReports,
  notifications: IconNotifications,
  "price-update": IconPriceUpdate,
  opportunities: IconOpportunities,
  fundraising: IconFundraising,
  funded: IconFunded,
  "browse-projects": IconOpportunities,
  "redeemed-projects": IconRedeemedProjects,
  "closed-projects": IconClosedProjects,
  cancelled: IconCancelled,
  referral: IconReferralLink,
  transfer: IconTransfer,
  "transfer-eligible": IconTransfer,
  "offer-history": IconOfferHistory,
  redeemable: IconRedeemable,
  "redeem-eligible": IconRedeemable,
  "request-history": IconOfferHistory,
  deposit: IconDeposit,
  withdraw: IconWithdraw,
  "wallet-activity": IconWalletActivity,
  filter: IconFilter,
};

export function InvestorMetricIcon({ name }) {
  const Icon = METRIC_ICON_BY_KEY[name];
  if (!Icon) return null;
  return <Icon />;
}

export function InvestorSectionIcon({ name }) {
  const Icon = SECTION_ICON_BY_KEY[name];
  if (!Icon) return null;
  return <Icon />;
}
